export default "__VITE_ASSET__BJxUHLMi__"